import { useEffect, useId, useRef, useState } from 'react'
import { Icon } from 'components/Icon'
import { useTranslation } from 'hooks/useTranslation'
import { FeedingInfoCard } from './FeedingInfoCard'
import { FeedingPillSelector } from './FeedingPillSelector'
import { Eyebrow } from './FeedingPillSelector/FeedingPillSelector.styles'
import { StickyFeedingBar } from './StickyFeedingBar'
import { useCurrentlyFeedingModule } from './useCurrentlyFeedingModule'
import {
  DesktopCard,
  DesktopModuleWrapper,
  MobileFixedContainer,
  MobilePanel,
  MobilePanelCloseButton,
  MobilePanelHeader,
} from './CurrentlyFeedingModule.styles'

export const CurrentlyFeedingModule = () => {
  const { t } = useTranslation()
  const headingId = useId()
  const mobileHeadingId = useId()
  const panelId = useId()
  const mobilePanelRef = useRef<HTMLDivElement>(null)
  const mobileTriggerRef = useRef<HTMLButtonElement>(null)
  const { selectedFeeding, isMobilePanelOpen, selectFeeding, toggleMobilePanel, closeMobilePanel } =
    useCurrentlyFeedingModule()

  const [hasOpenedPanel, setHasOpenedPanel] = useState(false)

  useEffect(() => {
    if (isMobilePanelOpen) {
      setHasOpenedPanel(true)
      mobilePanelRef.current?.focus()
    } else if (hasOpenedPanel) {
      mobileTriggerRef.current?.focus()
    }
    // Only run when the panel's open state changes, not on every selection change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobilePanelOpen])

  return (
    <>
      <DesktopModuleWrapper>
        <DesktopCard>
          <FeedingPillSelector
            selected={selectedFeeding}
            onSelect={selectFeeding}
            headingId={headingId}
          />
          {selectedFeeding && <FeedingInfoCard type={selectedFeeding} />}
        </DesktopCard>
      </DesktopModuleWrapper>

      <MobileFixedContainer>
        {isMobilePanelOpen && (
          <MobilePanel
            id={panelId}
            ref={mobilePanelRef}
            tabIndex={-1}
            role="region"
            aria-live="polite"
          >
            <MobilePanelHeader>
              <Eyebrow>{t('blog:currently-feeding.eyebrow')}</Eyebrow>
              <MobilePanelCloseButton
                type="button"
                onClick={closeMobilePanel}
                aria-label={t('common:close')}
              >
                <Icon name="close-line" size="3" />
              </MobilePanelCloseButton>
            </MobilePanelHeader>
            <FeedingPillSelector
              selected={selectedFeeding}
              onSelect={selectFeeding}
              headingId={mobileHeadingId}
              hideEyebrow
            />
            {selectedFeeding && <FeedingInfoCard type={selectedFeeding} />}
          </MobilePanel>
        )}
        <StickyFeedingBar
          ref={mobileTriggerRef}
          isOpen={isMobilePanelOpen}
          onToggle={toggleMobilePanel}
          panelId={panelId}
        />
      </MobileFixedContainer>
    </>
  )
}
